export default __webpack_public_path__ + "assets/puertoVallarta.52cd8875.jpg";